import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomerContactDetail = ({ icon, value, hideWhenEmpty = false }) => {
  if (hideWhenEmpty && !value) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-2">
      <FontAwesomeIcon icon={icon} className="text-secondary" />
      <h6 className="mb-0 lh-1">{value}</h6>
    </div>
  );
};

export default CustomerContactDetail;
